import { ThirdPartyType } from "~/enum/ThirdPartyType";

export class ThirdPartyHelper {
    static isThirdPartyProviderEnabled(
        thirdPartyEnum: ThirdPartyType,
        configuration: any
    ): boolean {
        if (
            configuration?.domainProperties?.thirdPartyProvidersDisabled &&
            configuration.domainProperties.thirdPartyProvidersDisabled.includes(thirdPartyEnum)
        ) {
            return false;
        }
        return true;
    }
}
